import "devextreme/dist/css/dx.dark.compact.css";
import { DataGrid } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  FilterRow,
  GroupItem,
  GroupPanel,
  Scrolling,
  SearchPanel,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import { forwardRef, useEffect, useState } from "react";
import { chooserColumn, sumHours, sumTotal } from "../reportLogic";
import {
  customer,
  description,
  hours,
  jobClass,
  jobId,
  phone,
  scheduledIn,
  total,
  vehicle,
  year,
  make,
  model,
  groupName,
  department,
  color,
} from "../reportColumns";

const columns = [
  jobId,
  chooserColumn(groupName),
  scheduledIn,
  chooserColumn(department),
  phone,
  customer,
  chooserColumn(description),
  vehicle,
  chooserColumn(color),
  chooserColumn(year),
  chooserColumn(make),
  chooserColumn(model),
  hours,
  jobClass,
  total,
];

const InventoryReport = forwardRef((props, ref) => {
  const { chartType, reportData } = props;
  const [data, setData] = useState();

  useEffect(() => {
    if (!!reportData) {
      setData(
        reportData.data.map((d) => {
          return {
            ...d,
            jobId: d.hat !== "" ? d.hat : d.jobAdminInt,
            vehicle: `${d.year} ${d.color} ${d.make} ${d.model}`,
          };
        })
      );
    }
  }, [reportData]);

  return (
    <>
      {!!data ? (
        <DataGrid
          height="100%"
          dataSource={data}
          keyExpr="hat"
          columnAutoWidth={true}
          showColumnLines={false}
          showRowLines={false}
          showBorders={false}
          rowAlternationEnabled={true}
        >
          <Scrolling mode="infinite" />
          <FilterRow visible />
          <SearchPanel visible />
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <Summary>
            <TotalItem
              column="hat"
              summaryType="count"
              displayFormat="Job Count: {0}"
            />
            <TotalItem
              column="hours"
              summaryType="sum"
              customizeText={sumHours}
            />
            <TotalItem
              column="subTotal"
              summaryType="sum"
              customizeText={sumTotal}
            />
            <GroupItem
              column="hat"
              summaryType="count"
              showInGroupFooter={false}
              displayFormat="Job Count: {0}"
            />
            <GroupItem
              column="hours"
              summaryType="sum"
              displayFormat="Hours: {0}"
              alignByColumn={false}
              showInGroupFooter={false}
            />
            <GroupItem
              column="subTotal"
              summaryType="sum"
              customizeText={sumTotal}
              displayFormat="Total: {0}"
              alignByColumn={false}
              showInGroupFooter={false}
            />
          </Summary>
          {columns.map((c) => (
            <Column key={c.dataField} {...c} />
          ))}
        </DataGrid>
      ) : (
        <div> No Data to Display </div>
      )}
    </>
  );
});

export default InventoryReport;
